<template>
  <div>
    <vue-c3 :handler="handler"></vue-c3>
  </div>
</template>

<script>

import Vue from 'vue';
import VueC3 from 'vue-c3';
require('c3/c3.css');

export default {
  name: 'IngestMacroDistributionChart',
  components: {
    VueC3
  },
  props: {
    ingredients: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number,
      default: 250
    },
    width: {
      type: Number,
      default: 250
    }
  },
  data () {
    return {
      handler: new Vue(),
      kcal: 0,
      protein: 0,
      fat: 0,
      carbs: 0,
      colors: [
        '#9765E0',
        '#00C2BA',
        '#C4CC52'
      ]
    };
  },
  mounted () {
    this.draw();
  },
  computed: {
    getCarbsDistributionPercentage () {
      const total = this.getCarbsGrams();
      const totalCalories = this.getTotalCalories;
      return Math.round((total * 4 / totalCalories) * 100 * 100) / 100;
    },
    getProteinDistributionPercentage () {
      const total = this.getProteinGrams();
      const totalCalories = this.getTotalCalories;
      return Math.round((total * 4 / totalCalories) * 100 * 100) / 100;
    },
    getFatsDistributionPercentage () {
      const total = this.getFatGrams();
      const totalCalories = this.getTotalCalories;
      return Math.round((total * 9 / totalCalories) * 100 * 100) / 100;
    },
    getTotalCalories () {
      const total = this.ingredients.reduce((acc, ingredient) => {
        return acc + ingredient.calories;
      }, 0);
      return Math.round(total * 100) / 100;
    }
  },
  methods: {
    draw () {
      const proteinGrams = this.getProteinGrams().toFixed();
      const fatGrams = this.getFatGrams().toFixed();
      const carbGrams = this.getCarbsGrams().toFixed();
      const options = {
        size: {
          height: this.height,
          width: this.width
        },
        data: {
          columns: [
            ['Protein', this.getProteinDistributionPercentage],
            ['Fat', this.getFatsDistributionPercentage],
            ['Carbs', this.getCarbsDistributionPercentage]
          ],
          type: 'donut',
          names: {
            'Protein': this.$t('health.summary.protein'),
            'Fat': this.$t('health.summary.fat'),
            'Carbs': this.$t('health.summary.carbs')
          }
        },
        donut: {
          title: this.$t('health.summary.kcalTitle', {value: this.getTotalCalories}),
          label: {
            format: function (value) {
              return value;
            }
          }
        },
        color: {
          pattern: this.colors
        },
        tooltip: {
          format: {
            value: function (value, ratio, id) {
              if (id === 'Protein') {
                return proteinGrams + 'g';
              } else if (id === 'Fat') {
                return fatGrams + 'g';
              } else if (id === 'Carbs') {
                return carbGrams + 'g';
              }
            }
          }
        }
      };
      this.handler.$emit('init', options);
    },
    getCarbsGrams () {
      const total = this.ingredients.reduce((acc, ingredient) => {
        return acc + ingredient.carbohydrates;
      }, 0);
      return Math.round(total * 100) / 100;
    },
    getProteinGrams () {
      const total = this.ingredients.reduce((acc, ingredient) => {
        return acc + ingredient.proteins;
      }, 0);
      return Math.round(total * 100) / 100;
    },
    getFatGrams () {
      const total = this.ingredients.reduce((acc, ingredient) => {
        return acc + ingredient.fats;
      }, 0);
      return Math.round(total * 100) / 100;
    }
  },
  watch: {
    ingredients: {
      handler () {
        this.draw();
      },
      deep: true
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/IngestMacroDistributionChart.vue